import * as React from 'react';
type Props = {
  className?: string;
};
export function CartFilled({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-cartFilled"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.87601 5.16271L3.46386 5.47652L3.03 3.52415L4.60972 3.1731C5.47727 2.98031 6.35569 3.44954 6.6778 4.27783L6.95878 5.00035H19.6122C20.5168 5.00035 21.1219 5.93142 20.7545 6.75803L17.6468 13.7503H9.97063L10.1581 15.0003H17.4969V17.0003H10.1581C9.16813 17.0003 8.3271 16.276 8.18025 15.297L7.87891 13.2881L5.33911 6.35355L4.87601 5.16271ZM12.0196 19.3949C12.0196 20.2071 11.3613 20.8653 10.5491 20.8653C9.7369 20.8653 9.07868 20.2071 9.07868 19.3949C9.07868 18.5826 9.7369 17.9244 10.5491 17.9244C11.3613 17.9244 12.0196 18.5826 12.0196 19.3949ZM17.9013 19.3949C17.9013 20.2071 17.2431 20.8653 16.4309 20.8653C15.6187 20.8653 14.9604 20.2071 14.9604 19.3949C14.9604 18.5826 15.6187 17.9244 16.4309 17.9244C17.2431 17.9244 17.9013 18.5826 17.9013 19.3949ZM12.2486 12.4711L16.8411 7.40139L15.3589 6.05865L12.2514 9.48899L11.1424 8.26008L9.65759 9.60001L12.2486 12.4711Z"
        fill="#222222"
      />
    </svg>
  );
}
